import React from 'react';
import ChoroplethPattern from './ChoroplethPattern';

export default class ChoroplethDashedPattern extends ChoroplethPattern {
  render() {
    const density = this.props.patternDensity;
    const size = this.props.patternSize;
    const rotation = this.props.patternRotation;
    return (
      <pattern id={this.props.patternName} width={density} height={density}
        patternTransform={`rotate(${rotation})`} patternUnits="userSpaceOnUse">
        <rect width={density} height={density} fill={this.getBackgroundColor()}/>
        <rect y={0.5 * (density - size)} height={size} width={density} fill={this.getPatternColor()}></rect>
      </pattern>
    )
  };
}
